setTimeout(() => {
  /** Variables for responsive code **/
  var width = $(window).width();

  /** Images Slider Code **/
  const swiper = new Swiper(".swiper", {
    // Optional parameters
    loop: true,
    slidesPerView: 3,
    spaceBetween: 25,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
    },
  });


  /** Image with details slider section **/

  const detailsSwiper = new Swiper(".image-with-detials-details-slider", {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    parallax: true,
    paginationClickable: true,
    grabCursor: true,
    paginationClickable: true,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
      },
      1024: {
        spaceBetween: 30,
      },
    },
  });

  var slideNumber = 0;
  $(".ingredient-card").click(detailsSwiper, function () {
    slideNumber = $(this).data("slide");
    detailsSwiper.slideTo(slideNumber);

    $(".swiper-button").css("display", "block");
    var temp = $("#ingredient-card" + slideNumber);
    if (width > 1025) {
      var height = $(temp).height() + 30;
    } else if (width > 990 && width < 1025) {
      var height = $(temp).height() + 30;
    } else {
      var height = $(temp).height();
    }
    var divWidth = $("#ingredient-card1").width();
    var divMargin = $(".image-with-details-slider").css("margin-right");

    var top = "";
    if (width > 600) {
      if (slideNumber < 5) {
        top = height + "px";
      } else if (slideNumber < 9 && slideNumber > 4) {
        top = height * 2 + "px";
      } else if (slideNumber < 13 && slideNumber > 8) {
        top += height * 3 + "px";
      }
    }
    if (width < 600) {
      if (slideNumber < 3) {
        top = height + 30 + "px";
      } else if (slideNumber < 5 && slideNumber > 2) {
        top = height * 2 + 50 + "px";
      } else if (slideNumber < 7 && slideNumber > 4) {
        top = height * 3 + 70 + "px";
      } else if (slideNumber < 9 && slideNumber > 6) {
        top = height * 4 + 90 + "px";
      } else if (slideNumber < 11 && slideNumber > 8) {
        top = height * 5 + 150 + "px";
      } else if (slideNumber < 13 && slideNumber > 10) {
        top = height * 6 + 220 + "px";
      }
    }
    if (width < 370) {
      if (slideNumber < 13 && slideNumber > 10) {
        top = height * 6 + 240 + "px";
      }
    }
    var right = divMargin + "px";

    $("#slider-div").css({
      position: "absolute",
      right: right,
      top: top,
      background: "white",
    });

    var marginTop = 0;
    if (width > 600) {
      marginTop = $("#slider-div").height() + 30;
      if (slideNumber < 5) {
        $(".desk-row-2").css("margin-top", marginTop);
        $(".desk-row-3").css("margin-top", 0);
        $(".desk-row-3").css("margin-bottom", 0);
      } else if (slideNumber < 9 && slideNumber > 4) {
        $(".desk-row-3").css("margin-top", marginTop);
        $(".desk-row-3").css("margin-bottom", 0);
        $(".desk-row-2").css("margin-top", 0);
      } else if (slideNumber < 13 && slideNumber > 8) {
        $(".desk-row-3").css("margin-bottom", marginTop);
        $(".desk-row-3").css("margin-top", 0);
        $(".desk-row-2").css("margin-top", 0);
      }
    }
    if (width < 600) {
      marginTop = $(".image-with-detials-details-slider").height() + 30;
      if (slideNumber < 3) {
        $(".mobile-row-2").css("margin-top", marginTop);
        $(".mobile-row-3").css("margin-top", 0);
        $(".mobile-row-4").css("margin-top", 0);
        $(".mobile-row-5").css("margin-top", 0);
        $(".mobile-row-6").css("margin-top", 0);
        $(".mobile-row-6").css("margin-bottom", 0);
      } else if (slideNumber < 5 && slideNumber > 2) {
        $(".mobile-row-3").css("margin-top", marginTop);
        $(".mobile-row-2").css("margin-top", 0);
        $(".mobile-row-4").css("margin-top", 0);
        $(".mobile-row-5").css("margin-top", 0);
        $(".mobile-row-6").css("margin-top", 0);
        $(".mobile-row-6").css("margin-bottom", 0);
      } else if (slideNumber < 7 && slideNumber > 4) {
        $(".mobile-row-4").css("margin-top", marginTop);
        $(".mobile-row-2").css("margin-top", 0);
        $(".mobile-row-3").css("margin-top", 0);
        $(".mobile-row-5").css("margin-top", 0);
        $(".mobile-row-6").css("margin-top", 0);
        $(".mobile-row-6").css("margin-bottom", 0);
      } else if (slideNumber < 9 && slideNumber > 6) {
        $(".mobile-row-5").css("margin-top", marginTop);
        $(".mobile-row-2").css("margin-top", 0);
        $(".mobile-row-4").css("margin-top", 0);
        $(".mobile-row-3").css("margin-top", 0);
        $(".mobile-row-6").css("margin-top", 0);
        $(".mobile-row-6").css("margin-bottom", 0);
      } else if (slideNumber < 11 && slideNumber > 8) {
        $(".mobile-row-6").css("margin-top", marginTop + 10);
        $(".mobile-row-2").css("margin-top", 0);
        $(".mobile-row-4").css("margin-top", 0);
        $(".mobile-row-5").css("margin-top", 0);
        $(".mobile-row-3").css("margin-top", 0);
        $(".mobile-row-6").css("margin-bottom", 0);
      } else if (slideNumber < 13 && slideNumber > 10) {
        $(".mobile-row-6").css("margin-bottom", marginTop);
        $(".mobile-row-2").css("margin-top", 0);
        $(".mobile-row-4").css("margin-top", 0);
        $(".mobile-row-5").css("margin-top", 0);
        $(".mobile-row-3").css("margin-top", 0);
        $(".mobile-row-6").css("margin-top", 0);
      }
    }

    $(".image-with-detials-details-slider").css("display", "block");

    if (width > 1025) {
      $(this).find(".show-details-plus").css("display", "none");
      $(this).find(".show-details-minus").css("display", "block");
    }
  });

  $(".ingredient-details .close-slider").click(function () {
    $(".image-with-detials-details-slider").css("display", "none");

    $(".swiper-button").css("display", "none");
    if (width > 1025) {
      $(".show-details-minus").css("display", "none");
    }
    if (width > 600) {
      if (slideNumber < 5) {
        $(".desk-row-2").css("margin-top", 0);
      } else if (slideNumber < 9 && slideNumber > 4) {
        $(".desk-row-3").css("margin-top", 0);
      } else if (slideNumber < 13 && slideNumber > 8) {
        $(".desk-row-3").css("margin-bottom", 0);
      }
    }
    if (width < 600) {
      $(".mobile-row-2").css("margin-top", 0);
      $(".mobile-row-3").css("margin-top", 0);
      $(".mobile-row-4").css("margin-top", 0);
      $(".mobile-row-5").css("margin-top", 0);
      $(".mobile-row-6").css("margin-top", 0);
      $(".mobile-row-6").css("margin-bottom", 0);
    }
  });
  
}, 2000);

